// @ts-nocheck
import React from 'react';
import { ChevronIcon } from '@ticketmaster/global-design-system';
import styles from './arrow.module.scss';

const SlickArrow = ({ onClick, direction = 'right', disabled = false }) => (
  <button
    className={`${styles.slickArrow} ${disabled ? styles.disabled : null}`}
    aria-disabled={disabled}
    aria-label={direction === 'right' ? 'Next' : 'Previous'}
    onClick={!disabled ? onClick : undefined}
  >
    <ChevronIcon size={15} fillColor={disabled ? '#bababa' : '#514e4e'} rotate={direction === 'right' ? -90 : 90} />
  </button>
);

export default SlickArrow;
